// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_by_id_header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #F2F3FC;
  padding: 20px;
  border-radius: 15px;
}

.user_by_id_informations,
.user_by_id_features {
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 200px;
  align-items: center;
  background-color: #F2F3FC;
  padding: 20px;
  border-radius: 15px;
}

.user_by_id_kyc {
  width: 35%;
  background-color: #F2F3FC;
  padding: 20px;
  border-radius: 15px;
}

.user_by_id_kyc_box {
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 200px;
  align-items: center;

}

.user_by_id_image {
  display: flex;
  flex-direction: column;
  background-color: #F2F3FC;
  padding: 20px;
  border-radius: 15px;
}

.userById_container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.user_by_id_profil {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 10px;
}

.user_profile_pic {
  width: 60px;
  height: 60px;
  border-radius: 10px;
}


.user_profil_name {
  display: flex;
  gap: 5px;
  margin: 0px;
  font-size: 20px;
  font-weight: 600;
  color: #000;
}


.user_profil_email {
  margin: 0px;
  font-size: 16px;
  font-weight: 600;
  color: #5c5c5c;
}

.user_header_action_button_box {
  display: flex;
  flex-direction: row;
  gap: 10px
}

.user_by_id_action_button,
.user_by_id_update_features {
  background-color: #2B64F5;
  padding: 15px 30px;
  border-radius: 5px;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.user_by_id_update_cancel_button {
  background-color: #c21c1c;
  padding: 15px 30px;
  border-radius: 5px;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-right: 10px;
}

.user_by_id_registerinfo {
  display: flex;
  flex-direction: column;
}

.user_document_upload{
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.user_documents_types_container {
  display: flex;
  flex-direction: column;
  gap: 50px
}

.user_document_type{
  margin: 0 0 20px 0;
  font-size: 19px;
  font-weight: bold;
}

.user_document_sumsub_type{
  font-size: 19px;
  font-weight: bold;
}

.user_file_upload {
  display: none;
}

.user_by_id_documents_container {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.user_by_id_documents {
  max-width: 200px;
}

.user_by_id_doc_item {
  max-width: 200px;
  border-radius: 16px;
}

.user_doc_title {
  margin: 0 0 20px 0;
  font-size: 22px;
  font-weight: bold;
}

.user_by_id_p {
  margin: 5px 0;
}

.user_by_id_chiffres {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.user_by_id_chiffres_user {
  width: 35%;
  display: flex;
  flex-direction: column;
  background-color: #F2F3FC;
  padding: 20px;
  border-radius: 15px;
}

.user_by_id_leverage {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #F2F3FC;
  padding: 20px;
  border-radius: 15px;
}

.user_by_id_case {
  display: flex;
  flex-direction: column;
  background-color: #F2F3FC;
  padding: 20px;
  border-radius: 15px;
  gap: 15px;
}

.user_by_id_fraud {
  display: flex;
  flex-direction: column;
  background-color: #F2F3FC;
  padding: 20px;
  border-radius: 15px;
  width: 65%
}

.user_by_id_fraud_box {
  display: flex;
  flex-direction: column;
  align-items: left;
  gap: 20px;
}

.user_by_id_free_transactions_update_box {
  display: flex;
  flex-direction: row;
  gap: 10px
}

.user_by_id_free_transactions_input {
  line-height: 1.6rem;
  width: 100px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0px 10px;
}

.user_by_id_free_transactions_button {
  background-color: #2B64F5;
  padding: 8px 16px;
  border-radius: 5px;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  color: #fff;
}

.user_by_id_free_transactions_title {
  margin: 0;
  font-size: 14px;
  color: #7f7f7f;
}

.user_by_id_chiffres_wallet {
  width: 65%;
  display: flex;
  flex-direction: column;
  background-color: #F2F3FC;
  padding: 20px;
  border-radius: 15px;
}

.user_by_id_wallet_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.user_by_id_report_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.user_by_id_item_title {
  margin: 0;
  font-size: 14px;
  display: block;
  color: #7f7f7f;
}

.user_by_id_item_desc {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #5c5c5c;
}

.user_by_id_box {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.user_by_id_item_edition {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #5c5c5c;
}

.user_by_id_edition_input {
  width: 300px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0px 10px;
}

.history_export_box {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  gap: 80px;
}

.history_export_box_item {
  display: flex;
  flex-direction: row;
  gap: 7px;
  align-items: center;
}

.history_export_button {
  background-color: #2B64F5;
  padding: 5px 20px;
  border-radius: 5px;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
  color: #fff;
}

.history_export_button:disabled {
  background-color: #86a5f4;
}

.label_title {
  margin: 0;
  font-size: 15px;
  display: block;
  color: #7f7f7f;
}

.label_value {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #5c5c5c;
}

.update_risk_level_box {
  display: flex;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/users/UserById/user.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX","sourcesContent":[".user_by_id_header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #F2F3FC;\n  padding: 20px;\n  border-radius: 15px;\n}\n\n.user_by_id_informations,\n.user_by_id_features {\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  gap: 200px;\n  align-items: center;\n  background-color: #F2F3FC;\n  padding: 20px;\n  border-radius: 15px;\n}\n\n.user_by_id_kyc {\n  width: 35%;\n  background-color: #F2F3FC;\n  padding: 20px;\n  border-radius: 15px;\n}\n\n.user_by_id_kyc_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  gap: 200px;\n  align-items: center;\n\n}\n\n.user_by_id_image {\n  display: flex;\n  flex-direction: column;\n  background-color: #F2F3FC;\n  padding: 20px;\n  border-radius: 15px;\n}\n\n.userById_container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.user_by_id_profil {\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  align-items: center;\n  gap: 10px;\n}\n\n.user_profile_pic {\n  width: 60px;\n  height: 60px;\n  border-radius: 10px;\n}\n\n\n.user_profil_name {\n  display: flex;\n  gap: 5px;\n  margin: 0px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #000;\n}\n\n\n.user_profil_email {\n  margin: 0px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #5c5c5c;\n}\n\n.user_header_action_button_box {\n  display: flex;\n  flex-direction: row;\n  gap: 10px\n}\n\n.user_by_id_action_button,\n.user_by_id_update_features {\n  background-color: #2B64F5;\n  padding: 15px 30px;\n  border-radius: 5px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.user_by_id_update_cancel_button {\n  background-color: #c21c1c;\n  padding: 15px 30px;\n  border-radius: 5px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  color: #fff;\n  margin-right: 10px;\n}\n\n.user_by_id_registerinfo {\n  display: flex;\n  flex-direction: column;\n}\n\n.user_document_upload{\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.user_documents_types_container {\n  display: flex;\n  flex-direction: column;\n  gap: 50px\n}\n\n.user_document_type{\n  margin: 0 0 20px 0;\n  font-size: 19px;\n  font-weight: bold;\n}\n\n.user_document_sumsub_type{\n  font-size: 19px;\n  font-weight: bold;\n}\n\n.user_file_upload {\n  display: none;\n}\n\n.user_by_id_documents_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.user_by_id_documents {\n  max-width: 200px;\n}\n\n.user_by_id_doc_item {\n  max-width: 200px;\n  border-radius: 16px;\n}\n\n.user_doc_title {\n  margin: 0 0 20px 0;\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.user_by_id_p {\n  margin: 5px 0;\n}\n\n.user_by_id_chiffres {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.user_by_id_chiffres_user {\n  width: 35%;\n  display: flex;\n  flex-direction: column;\n  background-color: #F2F3FC;\n  padding: 20px;\n  border-radius: 15px;\n}\n\n.user_by_id_leverage {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: #F2F3FC;\n  padding: 20px;\n  border-radius: 15px;\n}\n\n.user_by_id_case {\n  display: flex;\n  flex-direction: column;\n  background-color: #F2F3FC;\n  padding: 20px;\n  border-radius: 15px;\n  gap: 15px;\n}\n\n.user_by_id_fraud {\n  display: flex;\n  flex-direction: column;\n  background-color: #F2F3FC;\n  padding: 20px;\n  border-radius: 15px;\n  width: 65%\n}\n\n.user_by_id_fraud_box {\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  gap: 20px;\n}\n\n.user_by_id_free_transactions_update_box {\n  display: flex;\n  flex-direction: row;\n  gap: 10px\n}\n\n.user_by_id_free_transactions_input {\n  line-height: 1.6rem;\n  width: 100px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 0px 10px;\n}\n\n.user_by_id_free_transactions_button {\n  background-color: #2B64F5;\n  padding: 8px 16px;\n  border-radius: 5px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 400;\n  color: #fff;\n}\n\n.user_by_id_free_transactions_title {\n  margin: 0;\n  font-size: 14px;\n  color: #7f7f7f;\n}\n\n.user_by_id_chiffres_wallet {\n  width: 65%;\n  display: flex;\n  flex-direction: column;\n  background-color: #F2F3FC;\n  padding: 20px;\n  border-radius: 15px;\n}\n\n.user_by_id_wallet_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.user_by_id_report_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.user_by_id_item_title {\n  margin: 0;\n  font-size: 14px;\n  display: block;\n  color: #7f7f7f;\n}\n\n.user_by_id_item_desc {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #5c5c5c;\n}\n\n.user_by_id_box {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.user_by_id_item_edition {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #5c5c5c;\n}\n\n.user_by_id_edition_input {\n  width: 300px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 0px 10px;\n}\n\n.history_export_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: left;\n  align-items: center;\n  gap: 80px;\n}\n\n.history_export_box_item {\n  display: flex;\n  flex-direction: row;\n  gap: 7px;\n  align-items: center;\n}\n\n.history_export_button {\n  background-color: #2B64F5;\n  padding: 5px 20px;\n  border-radius: 5px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: bold;\n  color: #fff;\n}\n\n.history_export_button:disabled {\n  background-color: #86a5f4;\n}\n\n.label_title {\n  margin: 0;\n  font-size: 15px;\n  display: block;\n  color: #7f7f7f;\n}\n\n.label_value {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #5c5c5c;\n}\n\n.update_risk_level_box {\n  display: flex;\n  gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
